<template>
  <div class="col-lg-5 mb-4 mb-lg-0" v-if="visibleMenu">
    <collapse-menu
      class="d-lg-none"
      :initial-item="initialItem"
      :items="navigationItems"
    />
    <nav class="d-none d-lg-block profile-navigation">
      <vl-button
        class="mb-2 w-100"
        v-for="(item, index) in navigationItems"
        size="large"
        :type="item.url == initialItem.url ? 'menu-active' : 'menu'"
        :key="index"
        @click.native="openLink(item)"
        >{{ item.title }}</vl-button
      >
    </nav>
  </div>
</template>
<script>
import CollapseMenu from '@components/@tehnobank/collapse-menu'
import VlButton from '@components/@tehnobank/ui/vl-button'
import { redirectTo } from '@javascript/utils/helper-methods'
import locales from './locales'
import main from '../main'
export default {
  name: 'MenuProfile',
  components: {
    VlButton,
    CollapseMenu,
  },
  mixins: [main],
  data: () => ({
    t: locales,
  }),
  methods: {
    openLink(item) {
      if (item.key.includes('my_prize')) {
        window.open(item.url, '_blank')
      } else {
        redirectTo(item.url)
      }
    },
  },
}
</script>
